import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../../hooks/useAuth';
import { criarProposta } from '../../services/propostaService';
import { listarSupervisores } from '../../services/supervisorService';

import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  MenuItem
} from '@mui/material';

function PropostaForm({ onSuccess }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [supervisores, setSupervisores] = useState([]);

  const [formData, setFormData] = useState({
    titulo: '',
    problemaPesquisa: '',
    estudanteId: user?.id,
    supervisorId: ''
  });
  useEffect(() => {
    const carregarSupervisores = async () => {
      try {
        const response = await listarSupervisores();
        console.log("Dados dos supervisores:", response.data.map(sup => ({
          id: sup.id,
          nome: sup.Usuario?.nome,
          area: sup.area_especializacao
        })));
        
        setSupervisores(response.data);
      } catch (err) {
        console.error("Erro ao buscar supervisores:", err);
        setSupervisores([]);
      }
    };
    carregarSupervisores();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (!formData.estudanteId) {
        throw new Error('ID do estudante não encontrado');
      }

      const response = await criarProposta({
        ...formData,
        status: 'PENDENTE'
      });

      console.log('Proposta criada:', response);
      if (onSuccess) onSuccess();
      navigate('/propostas');
    } catch (err) {
      console.error('Erro detalhado:', err);
      setError(err.response?.data?.message || 'Erro ao submeter proposta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        {/* Cabeçalho */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', pb: 2, mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            Submeter Proposta de TCC/Monografia
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Preencha os detalhes da sua proposta de pesquisa
          </Typography>
        </Box>

        {/* Mensagem de Erro */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {/* Formulário */}
        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Título da Proposta"
              name="titulo"
              value={formData.titulo}
              onChange={handleChange}
              required
              helperText="O título deve ser claro e refletir o objetivo principal da pesquisa"
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Problema de Pesquisa"
              name="problemaPesquisa"
              value={formData.problemaPesquisa}
              onChange={handleChange}
              required
              multiline
              rows={6}
              helperText="Descreva claramente o problema que sua pesquisa pretende abordar"
            />
          </Box>

          {/* Seleção de Supervisor */}
          <Box sx={{ mb: 4 }}>
          <TextField
  select
  fullWidth
  label="Supervisor"
  name="supervisorId"
  value={formData.supervisorId}
  onChange={handleChange}
  required
  helperText="Escolha um supervisor para orientar sua pesquisa"
>
  {supervisores.length > 0 ? (
    supervisores.map((supervisor) => (
      <MenuItem key={supervisor.id} value={supervisor.id}>
        {supervisor.Usuario?.nome || 'Nome não disponível'} - {supervisor.area_especializacao}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>Nenhum supervisor disponível</MenuItem>
  )}
</TextField>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            gap: 2, 
            pt: 2,
            borderTop: 1,
            borderColor: 'divider'
          }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/propostas')}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} />}
            >
              {loading ? 'Submetendo...' : 'Submeter Proposta'}
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}

PropostaForm.propTypes = {
  onSuccess: PropTypes.func
};

export default PropostaForm;
